import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { choice } from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/validateUtils/newIndex";
import draggable from "vuedraggable";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import PicUpload from "@/components/picUpload/index.vue";
import EditSortDialog from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/components/EditSortDialog.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import { getCatalog, EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
import { randomNumber } from "@/utils/commonUtil";
import participantAutoFillConfig from "./participantAutoFillConfig.vue";
let SingleChoice = class SingleChoice extends Vue {
  constructor() {
    super(...arguments);
    this.editSortDialogKey = Math.random();
    this.drag = false;
    this.loading = false;
    this.catalogList = [];
    this.postForm = {
      title: "请选择以下选项",
      itemScore: 0,
      required: "1",
      optionContentType: "TEXT",
      optionsList: [{
        value: "选项1",
        content: "选项1",
        rightOption: true,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        },
        id: 0
      }, {
        value: "选项2",
        content: "选项2",
        rightOption: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        },
        id: 1
      }],
      jsonConfig: {
        showIndex: true,
        openPoint: false
      },
      catalogIds: [],
      whetherJoinQuestionBank: false
    };
    this.optionValidator = choice.content;
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        type: "string",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }],
      itemScore: [{
        required: true,
        message: "请填写题目分值",
        trigger: "blur"
      }],
      optionsList: [{
        required: true,
        type: "array",
        validator: choice.optionsList
      }],
      // catalogIds: [{ required: true, type: "array", message: "请选择分类名", trigger: "blur" }],
      whetherJoinQuestionBank: [{
        required: true,
        message: "请选择是否加入题库",
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    console.warn("postForm", this.postForm);
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  optionContentTypeChange() {
    this.postForm.optionsList.forEach(item => {
      item.content = "";
    });
  }
  clearOption(clickindex) {
    for (const index in this.postForm.optionsList) {
      if (index != clickindex) {
        this.postForm.optionsList[index].rightOption = false;
      }
    }
  }
  emitChange() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  removeOption(item, index) {
    this.postForm.optionsList.splice(index, 1);
    this.emitChange();
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get communityType() {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }
  get basicParams() {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType
    };
  }
  addOption() {
    const str = this.postForm.optionContentType == "TEXT" ? "选项" + (this.postForm.optionsList.length + 1) : "";
    this.postForm.optionsList.push({
      value: str,
      content: str,
      rightOption: false,
      jsonConfig: {
        openPoint: false,
        pointValue: undefined
      },
      id: Number("1" + (randomNumber(6) + "")) * -1
    });
    this.emitChange();
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  validateOptions() {
    this.getFormInstance().validateField("optionsList");
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  remoteMethod(query) {
    this.loading = true;
    getCatalog({
      ...this.basicParams,
      name: query,
      pageSize: 50,
      pageNum: 1
    }).then(res => {
      this.catalogList = res.rows || [];
    }).finally(() => this.loading = false);
  }
  catalogFocus() {
    if (this.catalogList.length === 0) {
      this.remoteMethod();
    }
  }
  openSortDialog() {
    this.$refs.editSortDialog.onShow({
      isBusinessTypeDisable: true,
      formData: {
        businessType: this.questionnaireType
      }
    });
  }
  async validate() {
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
  // $ 开始拖拽
  onStart() {
    this.drag = true;
  }
  // $ 结束拖拽
  onEnd() {
    this.drag = false;
    this.emitChange();
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], SingleChoice.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], SingleChoice.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], SingleChoice.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], SingleChoice.prototype, "watchPostForm", null);
SingleChoice = __decorate([Component({
  name: "singleChoicePicker",
  components: {
    PicUpload,
    questionSettingTemplate,
    draggable,
    EditSortDialog,
    participantAutoFillConfig
  }
})], SingleChoice);
export default SingleChoice;